module.exports = __webpack_public_path__ + "img/RS-M-3.ce54a51d.svg";